export default "__VITE_ASSET__CmwiCWR3__"